export default "__VITE_ASSET__QQWwFODX__"